/** Permissão do submenu B4 - Consultas no menu principal do coletor. */
export const ACESSO_MENU_CONSULTAS = "mni_ColetorDadosConsultas";

/**
 * Confirma se o usuário pode abrir as consultas do coletor.
 *
 * Algumas bases liberam o submenu B4 inteiro e outras liberam diretamente a
 * consulta interna. As duas formas são válidas no cadastro legado.
 */
export function temAcessoConsulta(permissoes: string[], acessoEspecifico: string): boolean {
	return permissoes.includes(ACESSO_MENU_CONSULTAS)
		|| permissoes.includes(acessoEspecifico);
}
